import React, { useState } from "react";
import { LOCATIONS } from "./LocationsData";
import Locations from "./Locations";
import LocationDetails from "./LocationDetails";
import WorkforceGuide from "./WorkforceGuide";

const LocationsWrapper = () => {
    const [selectedId, setSelectedId] = useState(1);

    const selectedCountry = LOCATIONS.find((loc) => loc.id === selectedId);

    return (
        <div className="space-y-6">
            <Locations 
                locations={LOCATIONS}
                selectedId={selectedId}
                setSelectedId={setSelectedId} 
            />
            <LocationDetails country={selectedCountry} />
            <WorkforceGuide country={selectedCountry} />
        </div>
    );
};

export default LocationsWrapper;
